import styled from "styled-components";
import Container from "../UI/Container";
import Flex from "../UI/Flex";

const StyledHeader = styled.header`
  background-color: ${({ theme }) => theme.colors.accent+"55"};
  height: 80px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  backdrop-filter: blur(4px);
  .header {
    &__wrapper {
      height: 100%;
    }
    &__inner {
      &--center {
        width: 100%;
        height: 100%;
      }
      &--aside {
        height: 100%;
        width: 100%;
      }
      }
    }
  }
`

const Header = () => {
  return (
    <StyledHeader>
      <Flex justify={'space-between'} className={'header__wrapper'}>
        <Flex direction={"row"} align={'center'} className={'header__inner--aside'}>
          <h1>Header content 1</h1>
        </Flex>
        <Container vCentered className={'header__inner--center'}>
          <Flex direction={"row"} align={'center'}>
            <h1>Header content 2</h1>
          </Flex>
        </Container>
        <Flex direction={"row"} align={'center'} className={'header__inner--aside'}>
          <h1>Header content 3</h1>
        </Flex>
      </Flex>
    </StyledHeader>
  );
};

export default Header;